import { HomeModernIcon, ChartBarIcon, CpuChipIcon, FolderIcon } from '@heroicons/react/24/outline';

const SystemModulesSection = () => {
  const modules = [
    {
      icon: HomeModernIcon,
      title: 'Home Safety Scan',
      badge: 'Powered by ThriveVision',
      description: 'Identifies everyday risks like rugs, lighting, and stairs so your home continues to support your independence.'
    },
    {
      icon: ChartBarIcon,
      title: 'Health Pulse',
      description: 'Helps you notice how your body is trending over time so small changes stay manageable and clear.'
    },
    {
      icon: CpuChipIcon,
      title: 'Cognitive Gear',
      description: 'Keeps your mind engaged and confident through simple daily challenges that never feel like homework.'
    },
    {
      icon: FolderIcon,
      title: 'Life Hub',
      description: 'One place for the practical details of daily life like documents, notes, and plans so nothing important gets lost.'
    }
  ];

  return (
    <section className="py-24 md:py-32 bg-gradient-to-br from-background via-accent/10 to-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            The Systems That Support Life at Home
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Designed to help you stay safe, feel steady, and keep daily life on track without effort.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {modules.map((module, index) => (
            <div 
              key={index} 
              className="bg-card rounded-2xl p-8 border border-accent/20 hover:border-primary/25 hover:shadow-lg hover:shadow-primary/5 transition-all duration-300 group"
            >
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/15 transition-colors">
                  <module.icon className="w-7 h-7 text-primary" />
                </div>
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="text-xl font-bold text-foreground">
                      {module.title}
                    </h3>
                    {module.badge && (
                      <span className="text-xs font-medium text-primary/70 bg-primary/10 px-2 py-0.5 rounded-full">
                        {module.badge}
                      </span>
                    )}
                  </div>
                  <p className="text-muted-foreground leading-relaxed">
                    {module.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SystemModulesSection;
